export default "__VITE_ASSET__BpZ5Ed2h__"